import { map } from 'rxjs';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { Observable } from 'rxjs';
import { StorageActions, StorageMsg } from 'src/core/engine';

import { CartActions, STORAGE_KEY_CART } from '../cart.actions';

/**
 * Listen for the cart being reset
 *
 * When that happens, also clear any localstorage data
 *
 * @param action$
 */
export function cartReset(action$: Observable<any>) {
    return action$.pipe(
        ofType<CartActions>('Cart.Reset'),
        map(() => StorageMsg(StorageActions.Delete, STORAGE_KEY_CART)),
    );
}
